import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import classNames from 'volta/helpers/class-names';
import BvText from 'volta/components/bv-text';
import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';
interface BvChoiceLabelSignature {
    Args: {
        disabled?: boolean;
        id?: string;
        label?: ContentValue;
        labelClass?: string;
        labelHidden?: boolean;
        onClick: () => void;
        onMouseOut: () => void;
        onMouseOver: () => void;
    };
    Blocks: {
        default: [];
    };
    Element: HTMLLabelElement;
}
const BvChoiceLabelComponent: TOC<BvChoiceLabelSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <label
    class={{classNames
      'bv-choice'
      (if @labelHidden 'bv-choice--label-hidden')
      (if @disabled 'bv-choice--disabled')
    }}
    for={{@id}}
    data-test-choice-label='{{@label}}'
    ...attributes
    {{on 'click' (optional @onClick)}}
    {{on 'mouseover' (optional @onMouseOver)}}
    {{on 'mouseout' (optional @onMouseOut)}}
  >
    <span class='bv-choice__control'>
      {{yield}}
    </span>
    <BvText class={{classNames 'bv-choice__label' @labelClass}}>
      {{@label}}
    </BvText>
  </label>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvChoiceLabelComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvChoice::Label': typeof BvChoiceLabelComponent;
        'bv-choice/label': typeof BvChoiceLabelComponent;
    }
}
